<template>
  <vs-popup class="raw-material-stock-popup"
            title="ADJUST FINISHED PRODUCT STOCK"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div id="raw-material-stock-popup" class="vx-row">
        <div class="vx-col lg:w-full w-full">
          <vs-table noDataText="">
            <template>
              <vs-tr>
                <vs-td class="font-semibold">ITS PROD CODE</vs-td>
                <vs-td>{{ data.formulation_code || ''}}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">ITS PROD NAME</vs-td>
                <vs-td>{{ data.name || ''}}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">CURRENCT STOCK LEVEL (KG)</vs-td>
                <vs-td>{{ toFixed(data.current_stock_level)}}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">CONFIRMED ORDER STOCK ALLOCATION (KG)</vs-td>
                <vs-td>{{ toFixed(data.confirmed_order_stock_allocation)}}</vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td class="font-semibold">AVAILABLE UNALLOCATED STOCK (KG)</vs-td>
                <vs-td>{{ toFixed(data.available_unallocated_stock)}}</vs-td>
              </vs-tr>


            </template>
          </vs-table>
        </div>
      </div>

      <formulation-stock-inventory v-bind:formulation_code="data.formulation_code"/>

<!--      <ValidationObserver ref="form" v-slot="{ handleSubmit }">-->
<!--        <form id="popup" @submit.prevent="handleSubmit(onClickUpdateStockLevel)" autocomplete="off">-->

<!--             <div class="vx-row mb-3 mt-2">-->
<!--              <div class="vx-col md:w-full md:mb-0">-->
<!--                <ValidationProvider vid="current_stock_level" name="current_stock_level" rules="required" v-slot="{ errors }">-->
<!--                  <small class="label">Current Stock Level</small>-->
<!--                  <vs-input v-model="createForm.current_stock_level"  name="current_stock_level" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                </ValidationProvider>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="vx-row mb-3 mt-2" >-->
<!--              <div class="vx-col md:w-full md:mb-0">-->
<!--                <ValidationProvider vid="reason" name="reason" rules="required" v-slot="{ errors }">-->
<!--                  <small class="label">Reason</small>-->
<!--                  <v-select  :clearable="true" name="reason" placeholder="" v-model="createForm.reason" :options="reasons" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>-->
<!--                  <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--                </ValidationProvider>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="vx-row mb-3 mt-2" v-if="createForm.reason === 'Other'">-->
<!--              <div class="vx-col md:w-full md:mb-0">-->
<!--                <ValidationProvider vid="other_reason" name="other_reason" rules="required" v-slot="{ errors }">-->
<!--                  <small class="label">Other Reason</small>-->
<!--                  <vs-input v-model="createForm.other_reason"  name="other_reason" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                </ValidationProvider>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="flex flex-wrap items-center justify-end mt-8" >-->
<!--              <vs-button id="save_change_button" button="submit" class="ml-auto mt-2">Save changes</vs-button>-->
<!--              <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>-->
<!--            </div>-->

<!--        </form>-->
<!--      </ValidationObserver>-->

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const InventoryRepository = RepositoryFactory.get('inventory')
  import FormulationStockInventory
    from "@/views/pages/manufacturing/formulation-stock/FormulationStockInventory";

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {current_stock_level: ''},
      current_stock_level: '',
      is_on_update: false,
      reasons: ['Assigned to NPD', 'Product Loss - Human error', 'Product Loss - Multiple weigh out', 'Sample to QC', 'Other']
    }
  }

export default {
  name: 'UpdateFinishedProductStockPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (data) {
      try {
        await Object.assign(this.$data, initialState())
        this.data = data
        this.createForm.current_stock_level = data.current_stock_level
        this.open = true;
      } catch (error) {

      }
    },

    async onClickUpdateStockLevel (){
      const vue = this
      await this.$vs.loading({
        container: '#save_change_button',
        scale: 0.45
      })
       try {
         let current_stock_level = Number(this.createForm.current_stock_level).toFixed(2)
         const payload = {current_stock_level: current_stock_level, reason_for_change: this.createForm.reason === 'Other' ? this.createForm.other_reason : this.createForm.reason}
         await InventoryRepository.updateFinishedProductCurrentStockLevel(this.data.id, payload)
         this.showSuccessMessage('Stock level updated successfully')
         this.open = false;
         await vue.$parent.refreshData()
         this.$vs.loading.close('#save_change_button > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#save_change_button > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },
    toFixed(number) {
      return Number(number).toFixed(3)
    }

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    FormulationStockInventory
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .raw-material-stock-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }

</style>
